import { TerminPoznamkaUpdateApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TerminPoznamkaUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTerminPoznamka = async (
  terminUuid: Uuid,
  poznamka: string,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { data, status } = await client
    .updateTerminPoznamka(terminUuid, { poznamka }, options);
  return { data, responseCode: status };
};
